// OLD PAGE LOADER
// import React from "react";
// import styles from "./Loader.module.scss";
// import { RevolvingDot } from "react-loader-spinner";
//
// const PageLoader = ({ text }) => {
//   return (
//     <div className={styles.pageLoader}>
//       <RevolvingDot
//         visible={true}
//         height="80"
//         width="80"
//         color="#007940"
//         ariaLabel="revolving-dot-loading"
//         wrapperStyle={{}}
//         wrapperClass=""
//       />
//       <span>{text}</span>
//     </div>
//   );
// };
//
// export default PageLoader;

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Loader.module.scss";
import LoaderGif from "../../icons/Borderly_loading.gif";

const LANGUAGE_COOKIE = "borderly_language";

const getLanguageFromCookie = () => {
  if (typeof document === "undefined") return null;
  const cookies = document.cookie?.split(";") || [];
  const match = cookies
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(`${LANGUAGE_COOKIE}=`));
  return match ? decodeURIComponent(match.split("=")[1]) : null;
};

const PageLoader = ({ text, translationKey }) => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const cookieLang = getLanguageFromCookie();
    if (cookieLang && cookieLang !== i18n.language) {
      i18n.changeLanguage(cookieLang);
    }
  }, [i18n]);

  const loaderText = translationKey
    ? t(translationKey, { defaultValue: text })
    : text || t("pageLoader.default");

  return (
    <div className={styles.pageLoader}>
      <img src={LoaderGif} alt="Loading..." className={styles.loaderGif} />
      {loaderText && <span>{loaderText}</span>}
    </div>
  );
};

export default PageLoader;
